"use client";

import { useStore } from "zustand";

import { ConfirmDialog } from "../ConfirmDialog";
import { confirmStore } from "./confirmStore";

/**
 * 確認ダイアログの表示ホスト（`Toaster` と同型）。`confirm(...)` で積まれた `confirmStore` を
 * 購読し、保留があるとき `ConfirmDialog` を1つ描く。グローバルに1つ置く（認証レイアウト）。
 * 同時に高々1件。
 */
export function ConfirmHost() {
    const pending = useStore(confirmStore, (s) => s.pending);
    const settle = useStore(confirmStore, (s) => s.settle);
    if (!pending) return null;
    return (
        <ConfirmDialog
            title={pending.title}
            body={pending.body}
            confirmLabel={pending.confirmLabel}
            cancelLabel={pending.cancelLabel}
            tone={pending.tone}
            onConfirm={() => settle(true)}
            onCancel={() => settle(false)}
        />
    );
}
